import { defineNuxtPlugin } from '#app/nuxt'
import { LazyDsBreadCrumb, LazyDsCrumb, LazyDsButtonBase, LazyDsButtonCritical, LazyDsButtonIconBase, LazyDsButtonIconCritical, LazyDsButtonIconPrimary, LazyDsButtonIconSecondary, LazyDsButtonIconTertiary, LazyDsButtonPrimary, LazyDsButtonSecondary, LazyDsButtonTertiary, LazyDsCheckbox, LazyDsDropdown, LazyDsDropdownDivider, LazyDsDropdownEmpty, LazyDsDropdownList, LazyDsDropdownListItem, LazyDsDropdownSection, LazyDsDropzone, LazyDsHeader, LazyDsProfileHeader, LazyDsIcon, LazyDsImage, LazyDsRadioButton, LazyDsEmptyState, LazyDsTabList, LazyDsTabListItem, LazyDsTag, LazyDsTagAction, LazyDsTagStatus, LazyDsTextBody, LazyDsTextHeading, LazyNuxtNotifications } from '#components'
const lazyGlobalComponents = [
  ["DsBreadCrumb", LazyDsBreadCrumb],
["DsCrumb", LazyDsCrumb],
["DsButtonBase", LazyDsButtonBase],
["DsButtonCritical", LazyDsButtonCritical],
["DsButtonIconBase", LazyDsButtonIconBase],
["DsButtonIconCritical", LazyDsButtonIconCritical],
["DsButtonIconPrimary", LazyDsButtonIconPrimary],
["DsButtonIconSecondary", LazyDsButtonIconSecondary],
["DsButtonIconTertiary", LazyDsButtonIconTertiary],
["DsButtonPrimary", LazyDsButtonPrimary],
["DsButtonSecondary", LazyDsButtonSecondary],
["DsButtonTertiary", LazyDsButtonTertiary],
["DsCheckbox", LazyDsCheckbox],
["DsDropdown", LazyDsDropdown],
["DsDropdownDivider", LazyDsDropdownDivider],
["DsDropdownEmpty", LazyDsDropdownEmpty],
["DsDropdownList", LazyDsDropdownList],
["DsDropdownListItem", LazyDsDropdownListItem],
["DsDropdownSection", LazyDsDropdownSection],
["DsDropzone", LazyDsDropzone],
["DsHeader", LazyDsHeader],
["DsProfileHeader", LazyDsProfileHeader],
["DsIcon", LazyDsIcon],
["DsImage", LazyDsImage],
["DsRadioButton", LazyDsRadioButton],
["DsEmptyState", LazyDsEmptyState],
["DsTabList", LazyDsTabList],
["DsTabListItem", LazyDsTabListItem],
["DsTag", LazyDsTag],
["DsTagAction", LazyDsTagAction],
["DsTagStatus", LazyDsTagStatus],
["DsTextBody", LazyDsTextBody],
["DsTextHeading", LazyDsTextHeading],
["NuxtNotifications", LazyNuxtNotifications],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
